import { useMutation, useQueryClient } from "@tanstack/react-query";
import { fapinstructorApi } from "../../api";
import { GET_PATREON_STATUS_QUERY_KEY } from "./get-patreon-status";

async function unlinkPatreonAccount() {
  await fapinstructorApi.post("/patreon/unlink").noContent();
}

export function useUnlinkPatreonAccount() {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: unlinkPatreonAccount,
    onSettled() {
      queryClient.invalidateQueries({
        queryKey: GET_PATREON_STATUS_QUERY_KEY,
      });
    },
  });

  return mutation;
}
